import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"min-width":"45vw"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThirdCompanyUsersEdition = _resolveComponent("ThirdCompanyUsersEdition")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialog) = $event)),
    "previous-display": _ctx.step !== 'default' && !_ctx.onlyToCreate,
    actions: _ctx.actions,
    prefixDataCy: "InvoiceThirdCompanyUsersDialog-valid"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ThirdCompanyUsersEdition, {
          actions: _ctx.actions,
          onlyToCreate: _ctx.onlyToCreate,
          companyId: _ctx.companyId,
          inThirdPartyCompanyId: _ctx.thirdPartyCompanyId,
          showEditUsers: false,
          onClient: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getValidFromChild($event))),
          onStep: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getStepFromChild($event))),
          onIsValid: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getIsValidFromChild($event)))
        }, null, 8, ["actions", "onlyToCreate", "companyId", "inThirdPartyCompanyId"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "previous-display", "actions"]))
}